import _ from "lodash";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useId, useState, useEffect } from "react";
import { compose } from "lib/apolloClient";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import Accordian from "UIComponents/Accordian";
import {
  Button,
  IconButton,
  Checkbox,
  Tag,
  ChecklistDropdown,
  FilterLabelButton,
  SelectDropdown,
  FormInputError,
  Alert,
  Tooltip,
  Badge,
} from "@toddle-edu/ds-web";
import { CloseOutlined, CaretDownFilled } from "@toddle-edu/ds-icons";
import { colors } from "Constants";
import classNames from "classnames";
import {
  GRADE_BOUNDARY_CREATION_EVENT,
  BULK_IMPORT_FROM_OTHER_TERM,
  BULK_DUPLICATE_TO_OTHER_SUBJECTS,
} from "Constants/stringConstants";
import { showToastAfterImportingTemplates } from "ScoreCategories/modules/ScoreCategoriesModule";
import {
  getSubjectLevelGenericTagsFromFlatVariants,
  getIsSubjectSelected,
  getUpdatedAssociatedEntities,
  getUpdatedAssociatedEntitiesForMultiSubjects,
  getSubjectCheckboxData,
  getIsCategorySetsExistsForAllSubjects,
  getIsTemplatesImportButtonDisabled,
  getUpdatedGradeOptions,
  getSelectedGradesDropdownLabel,
  getSubjectCheckboxDisabledTooltip,
  getRootNodesForBulkImport,
  getSubjectGroupsForBulkImport,
  getGradesOptionsForBulkImport,
  getTermsOptionsForBulkImport,
  getBulkDuplicateTemplateHeaderSubtext,
  getSelectableSubjectsCount,
  getBulkDuplicateTemplateHeaderTitle,
  getPluralLabelByParentType,
  getOverriddenGradeBoundaries,
} from "ScoreCategories/modules/Utils";
import { getCategorySets } from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentCategories/modules/AssessmentCategoriesModule";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { recordEvent } from "lib/eventTracker";
import classes from "./BulkDuplicateTemplateModal.scss";
import { connect } from "react-redux";
import { Trans } from "react-i18next";

const components = { b: <b /> };

const SubjectsList = ({
  t,
  subjects,
  sourceTermId,
  targetTermId,
  grades,
  gradeId,
  sourceSubjectId,
  gradeOptions,
  isCurriculumDP,
  associatedEntities,
  setAssociatedEntities,
  bulkSelectedGrades,
  isImportFromAnotherTerm,
  sourceTermLabel,
  parentType,
  sourceSubjectGenericTags,
  canOverrideExistingTemplates,
}) => {
  return _.map(subjects, subject => {
    const { id: subjectId, name, flatVariants, isArchived } = subject;

    const subjectLevelGenericTags = getSubjectLevelGenericTagsFromFlatVariants({
      flatVariants,
    });

    const {
      termsCategorySetsMappingWithGradesData,
      isCheckboxDisabled,
    } = getSubjectCheckboxData({
      subject,
      grades,
      sourceTermId,
      targetTermId,
      isImportFromAnotherTerm,
      sourceSubjectGenericTags,
      subjectLevelGenericTags,
      isCurriculumDP,
      canOverrideExistingTemplates,
    });

    const updatedGradesOptions = getUpdatedGradeOptions({
      t,
      gradeOptions,
      termsCategorySetsMappingWithGradesData,
      sourceTermLabel,
      isImportFromAnotherTerm,
      parentType,
      canOverrideExistingTemplates,
      gradeId,
      subjectId,
      sourceSubjectId,
    });

    const subjectNameClass = classNames("text-body-2", {
      [classes.textDisabled]: isCheckboxDisabled,
    });

    const subjectArchivedClass = classNames(
      "text-body-2",
      classes.textDisabled
    );

    const subjectLeftContainerClass = classNames(
      { [classes.subjectLeftContainer]: true },
      {
        [classes.subjectLeftContainerDP]: isCurriculumDP,
      }
    );

    const onClickDropdownOption = value => {
      const updatedAssociatedEntities = _.cloneDeep(associatedEntities);
      const arrIndex = _.findIndex(
        updatedAssociatedEntities,
        associatedEntity => _.get(associatedEntity, "subjectId") === subjectId
      );
      updatedAssociatedEntities[arrIndex] = {
        ...updatedAssociatedEntities[arrIndex],
        gradeIds: value,
      };
      setAssociatedEntities(updatedAssociatedEntities);
    };

    const selectedGradesOptions = _.get(
      _.find(
        associatedEntities,
        associatedEntity => _.get(associatedEntity, "subjectId") === subjectId
      ),
      "gradeIds",
      []
    );

    const isSubjectSelected = getIsSubjectSelected({
      associatedEntities,
      subjectId,
    });

    const selectedGradesDropdownLabel = getSelectedGradesDropdownLabel({
      t,
      selectedGradesOptions,
      grades,
      isSubjectSelected,
    });

    const onClickCheckbox = () => {
      if (!isCheckboxDisabled) {
        const updatedAssociatedEntities = getUpdatedAssociatedEntities({
          associatedEntities,
          bulkSelectedGrades,
          subjectId,
          grades,
          gradeId,
          sourceSubjectId,
          termsCategorySetsMappingWithGradesData,
          isImportFromAnotherTerm,
          canOverrideExistingTemplates,
        });
        setAssociatedEntities(updatedAssociatedEntities);
      }
    };

    const showErrorState =
      isSubjectSelected && _.isEmpty(selectedGradesOptions);

    let isChecklistDropdownDisabled = _.get(
      termsCategorySetsMappingWithGradesData,
      "1.isEveryGradeHasCategorySet"
    );

    if (canOverrideExistingTemplates) {
      isChecklistDropdownDisabled = !isSubjectSelected;
    }

    const subjectCheckboxConClass = classNames({
      [classes.subjectCheckboxCon]: true,
      [classes.clickable]: !isCheckboxDisabled,
    });

    return (
      <div key={subjectId} className={classes.subjectContainer}>
        <div className={subjectLeftContainerClass}>
          <div className={subjectCheckboxConClass} onClick={onClickCheckbox}>
            <ConditionalWrapper
              condition={isCheckboxDisabled}
              wrapper={
                <Tooltip
                  tooltip={getSubjectCheckboxDisabledTooltip({
                    t,
                    termsCategorySetsMappingWithGradesData,
                    sourceTermLabel,
                    isImportFromAnotherTerm,
                    parentType,
                    sourceSubjectGenericTags,
                    subjectLevelGenericTags,
                    isCurriculumDP,
                  })}
                  placement="left"
                />
              }
              type={"wrapperAsElement"}
            >
              <Checkbox
                isChecked={isSubjectSelected}
                disabled={isCheckboxDisabled}
              />
            </ConditionalWrapper>
            <div className={subjectNameClass}>{name}</div>
            {isArchived ? (
              <div className={subjectArchivedClass}>{`(${t(
                "common:archived"
              )})`}</div>
            ) : null}
          </div>
          <div className={classes.tagContainer}>
            {_.map(subjectLevelGenericTags, tag => {
              const tagLabel = _.get(tag, "label");
              return (
                <Tag color={tagLabel == "HL" ? "pink" : "teal"} size="x-small">
                  {tagLabel}
                </Tag>
              );
            })}
          </div>
        </div>
        <div className={classes.checklistDropdown}>
          <ChecklistDropdown
            options={updatedGradesOptions}
            value={selectedGradesOptions}
            showAllOption={true}
            allOptionLabel={t("common:all_grades")}
            showSelectedOptionsOnTop={false}
            checklistContainerClassName={classes.checklistDropdownClass}
            disabled={!isSubjectSelected || isChecklistDropdownDisabled}
            onChange={value => onClickDropdownOption(value)}
          >
            <FilterLabelButton
              size={"medium"}
              variant={showErrorState ? "inline-destructive" : "plain"}
              label={""}
              labelValue={selectedGradesDropdownLabel}
              style={{
                height: "40px",
                marginLeft: showErrorState ? "16px" : "0px",
              }}
            />
          </ChecklistDropdown>
        </div>
      </div>
    );
  });
};

const BulkDuplicateTemplateModal = props => {
  const {
    t,
    templateName,
    closeModal,
    grades,
    gradeId,
    sourceSubjectId,
    subjectGroups: allSubjectGroups,
    rootNodes: allRootNodes,
    isCurriculumDP,
    targetTermId,
    onClickImport,
    isImportFromAnotherTerm = false,
    terms,
    targetTermLabel,
    parentType = "ASSESSMENT_CATEGORIES",
    subjectName = "",
    showToastAfterImportingTemplates,
    sourceSubjectGenericTags,
    canOverrideExistingTemplates,
    isDuplicateToOtherSubjectsAndGradesFlow = false,
  } = props;

  const termErrorId = useId();

  const [bulkSelectedGrades, setBulkSelectedGrades] = useState([]);
  const [associatedEntities, setAssociatedEntities] = useState([]);
  const [sourceTerm, setSourceTerm] = useState(null);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const sourceTermId = _.get(sourceTerm, "value");
  const sourceTermLabel = _.get(sourceTerm, "label");

  const rootNodes = getRootNodesForBulkImport({
    allRootNodes,
    isImportFromAnotherTerm,
  });

  const subjectGroups = getSubjectGroupsForBulkImport({
    allSubjectGroups,
    rootNodes,
    isImportFromAnotherTerm,
  });

  const gradeOptions = getGradesOptionsForBulkImport({
    grades,
    subjectGroups,
    rootNodes,
    isCurriculumDP,
    targetTermId,
    canOverrideExistingTemplates,
  });

  const termsOptions = getTermsOptionsForBulkImport({
    t,
    terms,
    subjectGroups,
    rootNodes,
    grades,
    isCurriculumDP,
    targetTermId,
  });

  const gradeName = _.get(
    _.find(grades, grade => _.get(grade, "id") === gradeId),
    "name",
    ""
  );

  const stepsCount = canOverrideExistingTemplates ? 2 : 1;
  const isFirstStep = currentStepIndex === 0;
  const isLastStep = currentStepIndex === stepsCount - 1;

  useEffect(() => {
    setBulkSelectedGrades(
      _.map(
        _.filter(gradeOptions, option => !_.get(option, "disabled")),
        "value"
      )
    );
  }, [grades]);

  useEffect(() => {
    if (isImportFromAnotherTerm) {
      setSourceTerm(_.first(termsOptions));
    }
  }, [terms]);

  useEffect(() => {
    if (isImportFromAnotherTerm && !_.isEmpty(associatedEntities)) {
      setAssociatedEntities([]);
    }
  }, [sourceTermId]);

  const isAllCheckboxDisabled = getIsCategorySetsExistsForAllSubjects({
    subjects: rootNodes,
    grades,
    sourceTermId,
    targetTermId,
    isImportFromAnotherTerm,
    canOverrideExistingTemplates,
  });

  const subjectsIds = _.map(rootNodes, "id");

  const selectedSubjectsCount = _.get(
    _.filter(associatedEntities, associatedEntity =>
      _.includes(subjectsIds, _.get(associatedEntity, "subjectId"))
    ),
    "length",
    0
  );

  const selectableSubjectsCount = getSelectableSubjectsCount({
    subjects: rootNodes,
    grades,
    sourceTermId,
    targetTermId,
    isImportFromAnotherTerm,
    canOverrideExistingTemplates,
  });

  const onClickAllCheckbox = ({
    subjects = rootNodes,
    shouldApplyBulkGrades = false,
  }) => {
    const updatedAssociatedEntities = getUpdatedAssociatedEntitiesForMultiSubjects(
      {
        subjects,
        sourceTermId,
        targetTermId,
        grades,
        gradeId,
        sourceSubjectId,
        isImportFromAnotherTerm,
        associatedEntities,
        bulkSelectedGrades,
        selectedSubjectsCount,
        shouldApplyBulkGrades,
        canOverrideExistingTemplates,
      }
    );
    setAssociatedEntities(updatedAssociatedEntities);
  };

  useEffect(() => {
    const subjects = _.map(associatedEntities, associatedEntity =>
      _.find(
        rootNodes,
        node => _.get(node, "id") === _.get(associatedEntity, "subjectId")
      )
    );
    onClickAllCheckbox({ subjects, shouldApplyBulkGrades: true });
  }, [bulkSelectedGrades]);

  const onClickBulkImport = async () => {
    await onClickImport({
      associatedEntities,
      targetTermId,
      sourceTermId,
      rootNodes,
    });

    const templatesCount = _.sum(
      _.map(associatedEntities, ({ gradeIds }) => _.size(gradeIds))
    );

    if (parentType === "GRADE_BOUNDARIES") {
      recordEvent({
        eventName: GRADE_BOUNDARY_CREATION_EVENT,
        eventData: {
          entity_type: isImportFromAnotherTerm
            ? BULK_IMPORT_FROM_OTHER_TERM
            : BULK_DUPLICATE_TO_OTHER_SUBJECTS,
        },
      });
    }

    showToastAfterImportingTemplates({
      isImportFromAnotherTerm,
      parentType,
      t,
      targetTermLabel,
      selectedSubjectsCount,
      templatesCount,
    });
  };

  const onChangeTerm = term => {
    setSourceTerm(term);
  };

  let isPrimaryButtonDisabled = getIsTemplatesImportButtonDisabled({
    associatedEntities,
  });

  if (isLastStep && canOverrideExistingTemplates) {
    isPrimaryButtonDisabled = !isCheckboxChecked || isPrimaryButtonDisabled;
  }

  const subtext = getBulkDuplicateTemplateHeaderSubtext({
    t,
    isImportFromAnotherTerm,
    sourceTermLabel,
    targetTermLabel,
    parentType,
  });

  const subtextClass = classNames(classes.subtext, "text-body-2");
  const stepCountClass = classNames(classes.subtext, "text-label-4");

  const headerTitle = getBulkDuplicateTemplateHeaderTitle({
    parentType,
    isImportFromAnotherTerm,
    targetTermLabel,
    templateName,
    t,
    subjectName,
    gradeName,
    currentStepIndex,
  });

  const pointAssessmentSets = _.flatten(
    _.map(rootNodes, node => _.get(node, "pointAssessmentSets.edges", []))
  );

  const categorySets = getCategorySets({
    pointAssessmentSets,
    termId: sourceTermId,
  });

  const doesTermHaveNoTemplatesDefined = _.isEmpty(categorySets);

  const templateLabel = getPluralLabelByParentType({ t, parentType });

  const formErrorLocaleKey = doesTermHaveNoTemplatesDefined
    ? "academicSetup:there_are_no_label_created_in_this_term"
    : "academicSetup:there_are_no_label_that_can_be_imported_from_this_term";

  const formError = t(formErrorLocaleKey, {
    label: templateLabel,
  });

  const onClickPrimaryButton = () => {
    if (isLastStep) {
      onClickBulkImport();
    } else {
      setCurrentStepIndex(currentStepIndex + 1);
    }
  };

  const onClickSecondaryButton = () => {
    if (isFirstStep) {
      closeModal();
    } else {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  const onCheckboxClick = () => {
    setIsCheckboxChecked(!isCheckboxChecked);
  };

  const renderBodyContent = () => {
    switch (currentStepIndex) {
      case 0:
        return (
          <div className={classes.bodyContainer}>
            {isImportFromAnotherTerm ? (
              <div className={classes.termDropdownContainer}>
                <div className="text-label-2">
                  {t("academicSetup:import_label_from", {
                    label: getPluralLabelByParentType({ t, parentType }),
                  })}
                </div>
                <SelectDropdown
                  options={termsOptions}
                  size={"medium"}
                  placeholder={t("common:select")}
                  value={sourceTerm}
                  onChange={onChangeTerm}
                  isClearable={false}
                  error={isAllCheckboxDisabled}
                  aria-describedby={termErrorId}
                />
                <FormInputError
                  id={termErrorId}
                  error={isAllCheckboxDisabled ? formError : null}
                />
              </div>
            ) : null}

            {isImportFromAnotherTerm ||
            isDuplicateToOtherSubjectsAndGradesFlow ||
            parentType === "GRADE_SCALES" ? (
              <div className={classes.selectSubjectsTitleCon}>
                <span className="text-label-1">
                  {isImportFromAnotherTerm
                    ? t(
                        "academicSetup:select_subjects_you_want_to_import_label_for",
                        {
                          label: getPluralLabelByParentType({ t, parentType }),
                        }
                      )
                    : t(
                        "academicSetup:select_the_subjects_and_grade_levels_you_wish_to_duplicate"
                      )}
                </span>
                <span className={subtextClass}>{subtext}</span>
              </div>
            ) : null}

            {isCurriculumDP && !isImportFromAnotherTerm ? (
              <div className={classes.alertContainer}>
                <Alert
                  message={t("academicSetup:bulk_import_templates_alert_msg")}
                />
              </div>
            ) : null}
            <div className={classes.allSubjectsCheckboxCon}>
              <div className={classes.allCheckboxWrapperCon}>
                <div
                  className={classes.allCheckboxCon}
                  onClick={onClickAllCheckbox}
                >
                  <Checkbox
                    disabled={isAllCheckboxDisabled}
                    isIndeterminate={
                      selectedSubjectsCount > 0 &&
                      selectedSubjectsCount < selectableSubjectsCount
                    }
                    isChecked={
                      selectedSubjectsCount > 0 &&
                      selectedSubjectsCount === selectableSubjectsCount
                    }
                  />
                  <div className="heading-6">
                    {isImportFromAnotherTerm
                      ? t("academicSetup:import_for_all_subjects")
                      : t("academicSetup:all_subjects")}
                  </div>
                </div>
              </div>
              <div className={classes.applicableGradesCon}>
                <div className="heading-6">
                  {t("academicSetup:applicable_grades_small")}
                </div>
                <div className={classes.applicableGradesDropdown}>
                  <ChecklistDropdown
                    checklistLabel={t("common:bulk_select")}
                    options={gradeOptions}
                    value={bulkSelectedGrades}
                    showAllOption={true}
                    allOptionLabel={t("common:all_grades")}
                    showSelectedOptionsOnTop={false}
                    checklistContainerClassName={classes.checklistDropdownClass}
                    onChange={value => setBulkSelectedGrades(value)}
                  >
                    <IconButton
                      icon={<CaretDownFilled />}
                      variant={"plain"}
                      size={"x-small"}
                    />
                  </ChecklistDropdown>
                </div>
              </div>
            </div>
            {isCurriculumDP ? (
              _.map(subjectGroups, subjectGroup => {
                const { id: subjectGroupId, name, subjects } = subjectGroup;

                const isSubjectGroupDisabled = getIsCategorySetsExistsForAllSubjects(
                  {
                    subjects,
                    grades,
                    sourceTermId,
                    targetTermId,
                    isImportFromAnotherTerm,
                    canOverrideExistingTemplates,
                  }
                );

                const subjectsIds = _.map(subjects, "id");

                const selectedGroupSubjectsCount = _.get(
                  _.filter(associatedEntities, associatedEntity =>
                    _.includes(
                      subjectsIds,
                      _.get(associatedEntity, "subjectId")
                    )
                  ),
                  "length",
                  0
                );

                const selectableSubjectsCount = getSelectableSubjectsCount({
                  subjects,
                  grades,
                  sourceTermId,
                  targetTermId,
                  isImportFromAnotherTerm,
                  canOverrideExistingTemplates,
                });

                const onClickSubjectGroup = () => {
                  const updatedAssociatedEntities = getUpdatedAssociatedEntitiesForMultiSubjects(
                    {
                      subjects,
                      sourceTermId,
                      targetTermId,
                      grades,
                      gradeId,
                      sourceSubjectId,
                      isImportFromAnotherTerm,
                      associatedEntities,
                      bulkSelectedGrades,
                      selectedSubjectsCount: selectedGroupSubjectsCount,
                      canOverrideExistingTemplates,
                    }
                  );
                  setAssociatedEntities(updatedAssociatedEntities);
                };

                return !_.isEmpty(subjects) ? (
                  <div key={subjectGroupId} className={classes.flexCol}>
                    <div className={classes.subjectGroupWrapperCon}>
                      <div
                        className={classes.subjectGroupContainer}
                        onClick={onClickSubjectGroup}
                      >
                        <Checkbox
                          disabled={isSubjectGroupDisabled}
                          isIndeterminate={
                            selectedGroupSubjectsCount > 0 &&
                            selectedGroupSubjectsCount < selectableSubjectsCount
                          }
                          isChecked={
                            selectedGroupSubjectsCount > 0 &&
                            selectedGroupSubjectsCount ===
                              selectableSubjectsCount
                          }
                        />
                        <div className="text-label-2">
                          {t("common:all_in_label", { label: name })}
                        </div>
                      </div>
                    </div>
                    <SubjectsList
                      {...props}
                      subjects={subjects}
                      gradeOptions={gradeOptions}
                      associatedEntities={associatedEntities}
                      setAssociatedEntities={setAssociatedEntities}
                      bulkSelectedGrades={bulkSelectedGrades}
                      sourceTermId={sourceTermId}
                      sourceTermLabel={sourceTermLabel}
                      parentType={parentType}
                      sourceSubjectGenericTags={sourceSubjectGenericTags}
                      canOverrideExistingTemplates={
                        canOverrideExistingTemplates
                      }
                    />
                  </div>
                ) : null;
              })
            ) : (
              <SubjectsList
                {...props}
                subjects={rootNodes}
                gradeOptions={gradeOptions}
                associatedEntities={associatedEntities}
                setAssociatedEntities={setAssociatedEntities}
                bulkSelectedGrades={bulkSelectedGrades}
                sourceTermId={sourceTermId}
                sourceTermLabel={sourceTermLabel}
                parentType={parentType}
                canOverrideExistingTemplates={canOverrideExistingTemplates}
              />
            )}
          </div>
        );
      case 1: {
        const gradeBoundariesOverriddenClass = classNames(
          classes.textCritical,
          "text-label-2"
        );

        const overriddenGradeBoundaries = getOverriddenGradeBoundaries({
          grades,
          rootNodes,
          associatedEntities,
        });

        const getExpandedContent = () => {
          return _.map(overriddenGradeBoundaries, item => {
            const { key, subjectName, gradeName } = item;
            return (
              <div key={key} className={classes.subjectGradeNameCon}>
                <span className="text-body-1">{subjectName}</span>
                <span className="text-body-1">{gradeName}</span>
              </div>
            );
          });
        };

        const getConfirmationText = () => {
          if (isImportFromAnotherTerm) {
            return (
              <Trans
                i18nKey="academicSetup:grade_boundaries_importing_override_confirmation_with_label1_label2"
                components={components}
                values={{
                  label1: sourceTermLabel,
                  label2: targetTermLabel,
                }}
              >
                Please note that importing grade boundaries from
                <b>{{ label1: sourceTermLabel }}</b> to
                <b>{{ label2: targetTermLabel }}</b> will override the existing
                grade boundaries created in <b>{{ label2: targetTermLabel }}</b>
                for the subjects selected in the previous step. This would also
                cause the overall grade to be recalculated in the
                <b>{{ label2: targetTermLabel }}</b> gradebook and in unlocked
                progress reports for those subjects
              </Trans>
            );
          }

          return (
            <Trans
              i18nKey="academicSetup:grade_boundaries_duplication_override_confirmation_with_label"
              components={components}
              values={{
                label: `${targetTermLabel} - ${subjectName} - ${gradeName}`,
              }}
            >
              Please note that duplicating ‘
              <b>
                {{
                  label: `${targetTermLabel} - ${subjectName} - ${gradeName}`,
                }}
              </b>
              ’ grade boundary to other subjects will override the existing
              grade boundary defined in that subject. This would also cause the
              overall grade to be recalculated in the gradebook and in unlocked
              progress reports.
            </Trans>
          );
        };

        return (
          <div className={classes.bodyContainer}>
            <div className="text-label-1">{t("common:summary")}</div>
            <div className={classes.accordianContainer}>
              <Accordian
                customTitleComponent={
                  <div className={classes.justifyBetween}>
                    <div className={gradeBoundariesOverriddenClass}>
                      {t("academicSetup:grade_boundaries_overridden")}
                    </div>
                    <Badge
                      value={_.size(overriddenGradeBoundaries)}
                      size={"large"}
                      type={"numeric"}
                      variant={"subtle"}
                    />
                  </div>
                }
                showLabelBorder={false}
                hideContainerBorder={true}
                expandedContent={getExpandedContent()}
              />
            </div>
            <div className={classes.confirmationContainer}>
              <div className="text-label-1">{t("common:confirmation")}</div>
              <div className="text-body-1">{getConfirmationText()}</div>
              <div
                className={classes.confirmationAlertContainer}
                onClick={onCheckboxClick}
              >
                <Checkbox
                  isChecked={isCheckboxChecked}
                  color={{ background: colors.interactiveOneDefault }}
                />
                <span className="text-label-2">
                  {t(
                    "academicSetup:grade_boundaries_bulk_duplicate_import_confirmation"
                  )}
                </span>
              </div>
            </div>
          </div>
        );
      }
    }
  };

  return (
    <UIModal isOpen={true} modalContent={classes.modalContent}>
      <div className={classes.headerContainer}>
        <div className={classes.titleContainer}>
          {stepsCount > 1 ? (
            <div className={stepCountClass}>
              {t("common:current_step_of_all_steps", {
                currentCount: currentStepIndex + 1,
                totalCount: stepsCount,
              })}
            </div>
          ) : null}
          <div className="heading-4">{headerTitle}</div>
          {!isImportFromAnotherTerm && parentType !== "GRADE_SCALES" ? (
            <div className={subtextClass}>{subtext}</div>
          ) : null}
        </div>
        <IconButton
          icon={<CloseOutlined />}
          variant="plain"
          onClick={closeModal}
        />
      </div>

      {renderBodyContent()}

      <div className={classes.footerContainer}>
        <div className="text-label-2">
          {t("common:count_subjects_selected", {
            count: selectedSubjectsCount,
          })}
        </div>
        <div className={classes.footerRightContainer}>
          <Button
            size="large"
            variant="outlined-subtle"
            onClick={onClickSecondaryButton}
          >
            {isFirstStep ? t("common:cancel") : t("common:back")}
          </Button>
          <Button
            size="large"
            variant="progressive"
            disabled={isPrimaryButtonDisabled}
            onClick={onClickPrimaryButton}
          >
            {isLastStep
              ? isImportFromAnotherTerm
                ? t("common:import")
                : t("common:duplicate")
              : t("common:next")}
          </Button>
        </div>
      </div>
    </UIModal>
  );
};

const mapActionCreators = {
  showToastAfterImportingTemplates,
};

export default compose(
  connect(null, mapActionCreators),
  I18nHOC({ resource: ["common", "academicSetup", "toastMsgs"] })
)(BulkDuplicateTemplateModal);
